module.exports = __webpack_public_path__ + "img/fr1.d3fb37e1.jpg";